var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#9FA4A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 17.6667C28.502 17.6667 25.6665 20.5023 25.6665 24.0001C25.6665 27.4979 28.502 30.3334 31.9999 30.3334C35.4977 30.3334 38.3332 27.4979 38.3332 24.0001C38.3332 20.5023 35.4977 17.6667 31.9999 17.6667ZM27.6665 24.0001C27.6665 21.6068 29.6066 19.6667 31.9999 19.6667C34.3931 19.6667 36.3332 21.6068 36.3332 24.0001C36.3332 26.3933 34.3931 28.3334 31.9999 28.3334C29.6066 28.3334 27.6665 26.3933 27.6665 24.0001Z",
    fill: "#28475C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4739 35.4306C42.8702 35.8153 42.8797 36.4484 42.495 36.8447L40.0508 39.3632C39.8533 39.5667 39.5787 39.6767 39.2954 39.666C39.0121 39.6553 38.7466 39.5248 38.565 39.307L37.4537 37.9737C37.1001 37.5494 37.1574 36.9189 37.5816 36.5653C38.0058 36.2117 38.6364 36.2689 38.99 36.6932L39.3897 37.1727L41.0598 35.4518C41.4444 35.0555 42.0775 35.046 42.4739 35.4306Z",
    fill: "#28475C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6994 32.684C34.5357 32.4562 33.2911 32.3334 31.9999 32.3334C28.9151 32.3334 26.0731 33.0346 23.9671 34.2192C21.8925 35.3862 20.3332 37.1548 20.3332 39.3334L20.3331 39.4694C20.3316 41.0185 20.3297 42.9627 22.0351 44.3515C22.8744 45.0349 24.0485 45.5209 25.6348 45.842C27.2255 46.164 29.2988 46.3334 31.9999 46.3334C35.824 46.3334 38.4131 45.9949 40.1593 45.3448C41.7311 44.7596 42.6629 43.9022 43.1603 42.823C45.0568 41.7289 46.3332 39.6802 46.3332 37.3334C46.3332 33.8356 43.4977 31.0001 39.9999 31.0001C38.3397 31.0001 36.8288 31.6388 35.6994 32.684ZM35.6665 37.3334C35.6665 34.9402 37.6066 33.0001 39.9999 33.0001C42.3931 33.0001 44.3332 34.9402 44.3332 37.3334C44.3332 39.7267 42.3931 41.6667 39.9999 41.6667C37.6066 41.6667 35.6665 39.7267 35.6665 37.3334ZM34.3408 34.4867C33.9094 35.3426 33.6665 36.3096 33.6665 37.3334C33.6665 40.5191 36.0186 43.1555 39.0809 43.6006C37.6533 44.0489 35.4372 44.3334 31.9999 44.3334C29.3676 44.3334 27.4408 44.167 26.0316 43.8818C24.6179 43.5956 23.792 43.203 23.298 42.8006C22.3869 42.0588 22.3332 41.0772 22.3332 39.3334C22.3332 38.1983 23.1617 36.9669 24.9476 35.9623C26.7022 34.9754 29.1936 34.3334 31.9999 34.3334C32.8079 34.3334 33.5918 34.3867 34.3408 34.4867Z",
    fill: "#28475C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/user_check.f4950843d981215280e07128c022ca79.svg";
export { ForwardRef as ReactComponent };